import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-page.customize-active",
  "use": "icon-page.customize-active-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-page.customize-active\">\n<rect x=\"5\" y=\"6\" width=\"5\" height=\"1\" rx=\"0.5\" fill=\"#507afe\" />\n<rect x=\"5\" y=\"10\" width=\"5\" height=\"1\" rx=\"0.5\" fill=\"#507afe\" />\n<rect x=\"5\" y=\"8\" width=\"3\" height=\"1\" rx=\"0.5\" fill=\"#507afe\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol